import React from "react";
import { motion } from "framer-motion";
import { StarIcon } from "lucide-react";
import { TransformButton } from "./CtaButton";
interface Testimonial {
  quote: string;
  name: string;
  country: string;
  image: string;
}
const testimonials: Testimonial[] = [{
  quote: "Antes improvisaba todo: presupuestos, garantías y hasta los cobros. Hoy tengo un proceso claro y mis clientes me toman mucho más en serio.",
  name: "Carlos R.",
  country: "Colombia",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/6d9bdc18-07fd-48e9-8498-0e4d3cdd74ed.jpg"
}, {
  quote: "Solo el Sistema #6 vale muchísimo más de lo que pagué. Tener todos los formatos listos me ahorró semanas de trabajo.",
  name: "Miguel G.",
  country: "México",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/77054f49-2079-4145-9140-0d52a18bc5e0.jpg"
}, {
  quote: "Descubrí que estaba perdiendo dinero en casi todas mis reparaciones porque no calculaba mis costos. El Sistema Ganancia Real cambió mi forma de cobrar.",
  name: "José L.",
  country: "Venezuela",
  image: "https://cdn.magicpatterns.com/patterns/generated-images/9a1ccbcb-119c-4fb8-a944-e607f1b0b2af.jpg"
}];
export function Testimonials() {
  return <section className="w-full bg-neutral-950 py-14" data-id="element-189" data-mp="c6bwm8km22we">
      <div className="mx-auto max-w-lg px-4" data-id="element-190" data-mp="c8y1u1k146bg">
        <h2 className="text-center font-display text-2xl font-extrabold text-white sm:text-3xl" data-id="element-191" data-mp="zw64ebq2p19s">
          ⭐ Lo que dicen otros técnicos
        </h2>

        <div className="mt-8 space-y-4" data-id="element-192" data-mp="14xlpg3s937s6">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: "-60px"
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="rounded-2xl border border-white/10 bg-neutral-900 p-5" data-id="element-193" data-mp="q6cudf5kwu7n" data-mpi={i}>
              <div className="flex gap-0.5" data-id="element-194" data-mp="1xi93bb0tphe2">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="h-4 w-4 fill-amber-400 text-amber-400" data-id="element-195" data-mp="1sjz50rjsy0o8" data-mpi={s} />)}
              </div>
              <blockquote className="mt-3 text-sm leading-relaxed text-white/85" data-id="element-196" data-mp="1jir8of0uj9ws">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3" data-id="element-197" data-mp="1ekpo1pnrv2j7">
                <img src={t.image} alt={t.name} className="h-12 w-12 rounded-full border-2 border-amber-400/50 object-cover" data-id="element-198" data-mp="19s6autszy9ex" />
                <div data-id="element-199" data-mp="10sja8a83d7mx">
                  <div className="font-display text-sm font-bold text-white" data-id="element-200" data-mp="10t1cbnhfqg2r">
                    {t.name}
                  </div>
                  <div className="text-xs text-white/50" data-id="element-201" data-mp="vuq7xs9wsxrx">{t.country}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>

        <div className="mt-8 flex justify-center" data-id="element-202" data-mp="32ge18zt5uzvj">
          <TransformButton label="Quiero resultados como estos" data-id="element-203" data-mp="37fqo3kk186y4" />
        </div>
      </div>
    </section>;
}